import React from "react";

const SkeletonBlock = ({ className = "", style }) => (
    <div
        className={["dashboard-skeleton-block", className].filter(Boolean).join(" ")}
        style={style}
        aria-hidden="true"
    />
);

const DashboardSkeleton = ({ isAdmin = false, isHr = false }) => {
    const kpiCount = isAdmin || isHr ? 4 : 3;
    const quickActionCount = isAdmin ? 4 : isHr ? 4 : 3;

    return (
        <div className="dashboard-skeleton" role="status" aria-label="Loading dashboard">
            <span className="dashboard-skeleton-sr-only">Loading dashboard…</span>

            <SkeletonBlock className="dashboard-skeleton-hero" />

            <div
                className={[
                    "dashboard-skeleton-kpi-grid",
                    isAdmin
                        ? "dashboard-skeleton-kpi-grid--admin"
                        : isHr
                            ? "dashboard-skeleton-kpi-grid--hr"
                            : "dashboard-skeleton-kpi-grid--employee",
                ].join(" ")}
            >
                {Array.from({ length: kpiCount }).map((_, i) => (
                    <SkeletonBlock key={`kpi-${i}`} className="dashboard-skeleton-kpi-card" />
                ))}
            </div>

            <div className="dashboard-skeleton-attendance-row">
                <SkeletonBlock className="dashboard-skeleton-attendance-tile" />
                <SkeletonBlock className="dashboard-skeleton-attendance-tile" />
            </div>

            <SkeletonBlock className="dashboard-skeleton-section-title" />
            <div className="dashboard-skeleton-quick-actions">
                {Array.from({ length: quickActionCount }).map((_, i) => (
                    <SkeletonBlock key={`action-${i}`} className="dashboard-skeleton-action-card" />
                ))}
            </div>

            <SkeletonBlock className="dashboard-skeleton-section-title dashboard-skeleton-section-title--wide" />
            <SkeletonBlock className="dashboard-skeleton-projects" />

            <div className="dashboard-skeleton-widgets">
                {Array.from({ length: 3 }).map((_, i) => (
                    <SkeletonBlock key={`widget-${i}`} className="dashboard-skeleton-widget" />
                ))}
            </div>
        </div>
    );
};

export default DashboardSkeleton;
